import React from "react";
import { Line } from "@ant-design/plots";

import { TimedCounts } from "../../types/api";
import { ToFlatTimedCounts } from "./TimedCountsUtil";

export type TimedCountsPlotProps = {
  data: TimedCounts;
};

// Plots data sliced by time (x-axis), with multiple labels on y-axis.
export const TimedCountsPlot = (props: TimedCountsPlotProps) => {
  const [flat_keys, flats] = ToFlatTimedCounts(props.data);

  // Transform data to format expected by @ant-design/plots
  const chartData = flats.flatMap((point) => {
    return flat_keys.map((key) => ({
      date: point.xxx_tr_x_key,
      value: typeof point[key] === "number" ? point[key] : 0,
      category: key,
    }));
  });

  const config = {
    data: chartData,
    xField: "date",
    yField: "value",
    colorField: "category",
    shapeField: "smooth",
    height: 300,
    style: {
      lineWidth: 2,
    },
    scale: {
      y: {
        nice: true,
      },
    },
    axis: {
      y: {
        label: {
          formatter: (v: string) => Math.round(Number(v)).toString(),
        },
      },
    },
    legend: {
      color: {
        position: "top",
      },
    },
    tooltip: {
      shared: true,
      items: [
        {
          channel: "y",
          valueFormatter: (value: number) => value.toString(),
        },
      ],
    },
  };

  return <Line {...config} />;
};
